import InsuredCard from './InsuredCard'

export default InsuredCard
